import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAccess from '../hooks/useAccess';
import { homePathForRole } from './ProtectedRoute';

/**
 * Keeps each role inside its own application shell: back-office users cannot land on
 * /portal and client users cannot land on the back-office. A mismatch redirects to
 * that role's home rather than showing an error — it is navigation, not a denial.
 */
export const RoleRoute = ({ allow = [], children }) => {
  const { role } = useAccess();

  if (role && !allow.includes(role)) {
    return <Navigate to={homePathForRole(role)} replace />;
  }

  return children ? children : <Outlet />;
};

/**
 * Guards a back-office screen behind one module grant. This is a UI convenience —
 * the endpoints behind the screen enforce the same rule independently.
 */
export const ModuleRoute = ({ module, action = 'view', children }) => {
  const { can } = useAccess();

  if (!can(module, action)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children ? children : <Outlet />;
};

export default RoleRoute;
